import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Avatar } from '@material-ui/core';
import useStyles from './useStyles';

const UserImage = props => {
  const { className, imageUrl, size } = props;
  const classes = useStyles();

  const isSizeM = size === 'm';

  const classNames = clsx(className, classes.container, { [classes.medium]: isSizeM });

  return <Avatar variant="rounded" className={classNames} src={imageUrl} />;
};

UserImage.propTypes = {
  imageUrl: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.string,
};

UserImage.defaultProps = {
  imageUrl: '',
  className: '',
  size: 'm',
};

export default UserImage;



// WEBPACK FOOTER //
// ./src/sharedComponents/UserImage/UserImage.js